import React from 'react'
import { CrossClientQueryResultCellProps } from './types'
import { LinkButton } from '../../../../components/Button/LinkButton'

export const CrossClientQueryResultButtonsCell: React.FC<CrossClientQueryResultCellProps> = ({ result }) => {
  return (
    <div className='d-flex gap-2'>
      <LinkButton variant='borderless' className='p-2' to={`/email/new?contactId=${result.clientId}`} target='_blank'>
        <i className='bi bi-envelope' />{' '}
      </LinkButton>
      <LinkButton variant='borderless' className='p-2' to={`/library/manage-contacts/contacts/${result.clientId}`} target='_blank'>
        <i className='bi bi-arrow-up-right' />{' '}
      </LinkButton>
    </div>
  )
}
